import type { ViewPortType } from '@/engine/app/interfaces';
import type { IClippingController, IClippingManager } from './interfaces';
import type * as THREE from 'three';
import type { ViewsService } from '@/engine/app/Views.service';

export class ClippingManager implements IClippingManager {
  private _controllers = new Map<string, IClippingController>();

  private readonly _viewsService: ViewsService;

  public constructor(viewsService: ViewsService) {
    this._viewsService = viewsService;
  }

  public getClippingController(uuid: string): IClippingController | undefined {
    return this._controllers.get(uuid);
  }

  public registerClippingController(uuid: string, controller: IClippingController | undefined): void {
    this._controllers.get(uuid)?.dispose();
    if (controller === undefined) {
      this._controllers.delete(uuid);
    } else {
      this._controllers.set(uuid, controller);
      controller.trackPlaneChanged((plane: THREE.Plane) => {
        if (controller.isEnabled()) {
          this._viewsService.currentViewOrThrow.updateClippingPlane(uuid as ViewPortType, plane);
        }
      });
      controller.trackEnabledChanged((plane: THREE.Plane | null) => {
        this._viewsService.currentViewOrThrow.updateClippingPlane(uuid as ViewPortType, plane);
      });
    }
  }
}
